import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'
import '@/plugins/globals'
import '@/plugins/firebase'
import '@/plugins/registerServiceWorker'
import '@/plugins/vueMoment'
import '@/plugins/vueSwiper'
import '@/plugins/vueGoogle'

import {OneSignalInit} from '@/plugins/pushMessenging';
import i18n from '@/plugins/i18n';
import FlagIcon from 'vue-flag-icon';
import Axios from '@/plugins/axios';
import config from './config'
import { SplashScreen } from '@capacitor/splash-screen';
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
window.onload = function(){ 
  document.addEventListener("deviceready", OneSignalInit, false);
}
process.env.VUE_APP_VERSION = require('../package.json').version
process.env.PAGE_TITLE = 'eetplein'
Vue.prototype.$token = store.state.token
Vue.prototype.$http = Axios;
Vue.use(FlagIcon);
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App),
  beforeMount() {
    if (this.$OneSignal) this.$OneSignal.init(config.oneSignal);
  },
  mounted() {
    SplashScreen.hide()
    OneSignalInit(store.state.token, store.state.phone)
 }
}).$mount('#app')

